import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import AutoAcceptPriceChangesToggle from '../AutoAcceptPriceChangesToggle/AutoAcceptPriceChangesToggle';
import Keyboard from '../BetSlip/components/Keyboard/Keyboard';

import styles from './Footer.scss';
import Buttons from './components/Buttons/Buttons';
import Messages from './components/Messages/Messages';
import Totals from './components/Totals/Totals';

const Footer = () => {
  const hasSelections = useSelector(select.betSlip.hasSelections);

  return (
    <>
      <Keyboard />
      <div className={styles.footer} data-testid="bet-slip-footer">
        <Messages />

        {hasSelections ? (
          <>
            <AutoAcceptPriceChangesToggle />
            <Totals />
          </>
        ) : null}

        <Buttons />
      </div>
    </>
  );
};

export default Footer;
